export const getJobFieldsAPI = "/jobs/fields";
export const createJobFieldAPI = "/jobs/fields";
export function getJobFieldAPI(id) { return "/jobs/fields/" + id; }
export function deleteJobFieldAPI(id) { return "/jobs/fields/" + id; }
export function editJobFieldAPI(id) { return "/jobs/fields/" + id; }


